import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { QuillModule } from "ngx-quill";

import { RichTextEditorComponent } from "./components/rich-text-editor.component";
import { RichTextEditorChangeService } from "./services/rich-text-editor-change.service";
import { RichTextEditorToolbarService } from "./services/rich-text-editor-toolbar.service";


@NgModule({
    declarations: [
        RichTextEditorComponent,
    ],
    providers: [
        RichTextEditorToolbarService,
        RichTextEditorChangeService,
    ],
    imports: [
        FormsModule,
        QuillModule
    ],
    exports: [
        RichTextEditorComponent,
    ]
})
export class RichTextEditorModule {
}